import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";

import { TableCell, TableRow } from "@/components/ui/table";
import { Income } from "@/hooks/admin/shared/useIncome";
import { formatCurrency } from "@/utils/shared/currencyUtils";
import { formatFullNumericDateUTC } from "@/utils/shared/dateUtils";
import { Edit, Trash2 } from "lucide-react";

interface IncomeRowProps {
  income: Income;
  index: number;
  onEdit: (income: Income) => void;
  onDelete: (income: Income) => void;
  canEdit?: boolean;
  canDelete?: boolean;
  isSelected: boolean;
  onSelect: (incomeId: string, index: number, shiftKey: boolean) => void;
}

const IncomeRow = ({
  income,
  index,
  onEdit,
  onDelete,
  canEdit,
  canDelete,
  isSelected,
  onSelect,
}: IncomeRowProps) => (
  <TableRow>
    <TableCell onClick={(e) => onSelect(income.id, index, e.shiftKey)}>
      <Checkbox
        checked={isSelected}
        onCheckedChange={() => {}}
        aria-label={`Seleccionar ingreso ${income.booking_id}`}
      />
    </TableCell>

    <TableCell className="font-medium">
      <div>
        {income.booking_id}
        {income.guest_name && (
          <div className="text-xs text-muted-foreground mt-1">
            {income.guest_name.split(" ").slice(0, 2).join(" ")}
          </div>
        )}
      </div>
    </TableCell>

    <TableCell>{income.property_short_name || "-"}</TableCell>

    <TableCell>{income.income_type}</TableCell>
    <TableCell>{income.payment_type}</TableCell>
    <TableCell>{formatCurrency(income.gross_payment)}</TableCell>
    <TableCell>{formatCurrency(income.iva)}</TableCell>
    <TableCell>{formatCurrency(income.ret_iva)}</TableCell>
    <TableCell>{formatCurrency(income.ret_isr)}</TableCell>
    <TableCell>{formatCurrency(income.comission)}</TableCell>
    <TableCell>{formatCurrency(income.payout)}</TableCell>
    <TableCell>{formatFullNumericDateUTC(income.payout_date)}</TableCell>

    <TableCell>
      <span
        className={`px-2 py-1 rounded-full text-xs font-medium ${
          income.fiscal_invoice
            ? "bg-green-100 text-green-800"
            : "bg-destructive text-white"
        }`}
      >
        {income.fiscal_invoice ? "Sí" : "No"}
      </span>
    </TableCell>

    {(canEdit || canDelete) && (
      <TableCell className="flex items-center space-x-2">
        {canEdit && (
          <Button variant="outline" size="sm" onClick={() => onEdit(income)}>
            <Edit className="h-4 w-4" />
          </Button>
        )}

        {canDelete && (
          <Button
            variant="destructive"
            size="sm"
            onClick={() => onDelete(income)}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        )}
      </TableCell>
    )}
  </TableRow>
);

export default IncomeRow;
